export const borderRadius = {
    SMALL: '2px',
    PRIMARY: '4px',
    CIRCLE: '50%'
}